export function formatMapPrice(price, priceType) {
  if (!price || price < 1) return price === 0 ? '€0' : '€—';

  const pt = (priceType || '').toLowerCase();
  const isRent = ['per month', 'rent', 'rental', 'for_rent', 'rent_per_month'].includes(pt);

  if (isRent) {
    if (price >= 10000) return `€${Math.round(price / 1000)}k/mo`;
    return `€${price.toLocaleString('en-GB')}/mo`;
  }

  if (price >= 1_000_000) return `€${(price / 1_000_000).toFixed(1)}M`;
  if (price >= 1000) return `€${Math.round(price / 1000)}k`;
  return `€${price.toLocaleString('en-GB')}`;
}
